export function isErrorWithMessage(error) {
    return (error !== undefined &&
        error !== null &&
        typeof error === 'object' &&
        'message' in error);
}
export function isAPIError(error) {
    return isErrorWithMessage(error) && 'status' in error;
}
//# sourceMappingURL=error.js.map